import { render } from "./search-pager.vue?vue&type=template&id=56954634"
import script from "./search-pager.vue?vue&type=script&lang=js"
export * from "./search-pager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__